import React, {Component} from "react";
import {Button, Glyphicon, PageHeader} from "react-bootstrap";
import "./Clinics.css";
import {AgGridReact} from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import * as userLib from "../libs/user-lib";
import {columnDefsClinics} from "../libs/columnDefClinics";

const API = require("../libs/awsApiWrappers");

export default class Clinics extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            users: [],
            selectedClinics: [],
            isEditor: userLib.isCustomEditor(this.props.currentUser, 'clinic'),
            isViewer: userLib.isCustomViewer(this.props.currentUser, 'clinic'),

            columnDefs: columnDefsClinics,

            defaultColDef: {
                sortable: true,
                filter: true,
                lockPinned: true,
                resizable: true
            },
            style: {
                width: '100%',
                height: '644px'
                // height: '364px'
                // height: '2884px'
            },
            rowSelection: "single",
            paginationPageSize: 100,
            paginationNumberFormatter: function (params) {
                return params.value.toLocaleString();
            }
        };

        this.state.columnDefs[0].checkboxSelection = true;
        const self = this;
        this.state.columnDefs[0].cellRenderer = API.getCustomCellRenderer("clinics", self,
            () => { self.props.setClinicToDuplicate(null) });

    }

    onGridReady = params => {
        this.gridApi = params.api;
        // this.gridColumnApi = params.columnApi;

        const updateData = data => {
            this.props.setRowDataClinics(data);
            params.api.paginationGoToPage(0);
        };

        updateData(this.props.rowDataClinics);
        const value = this.props.searchBoxValue;
        document.getElementById('filter-text-box').value = value;
        params.api.setGridOption("quickFilterText", value);

        const valuePageSize = this.props.pageSize;
        document.getElementById("page-size").value = valuePageSize;
        this.gridApi.setGridOption("paginationPageSize", Number(valuePageSize));
    };


    onPageSizeChanged() {
        // const pxPerRow = 28;
        const value = document.getElementById("page-size").value;
        this.props.setPageSize(value);
         this.gridApi.setGridOption("paginationPageSize", Number(value));

        // const newHeight = ((Number(value) + 3) * pxPerRow).toString() + "px";
        // this.setHeight(newHeight);
    }

    onSelectionChanged() {
        this.setState({selectedClinics: this.gridApi.getSelectedRows()});
    }

    componentDidUpdate() {
        if (this.gridApi) {
            this.gridApi.refreshCells();
        }
    }

    async componentDidMount() {
        if (!this.props.isAuthenticated) {
            return;
        }
        this.setState({isEditor: userLib.isCustomEditor(this.props.currentUser, 'clinic')});
        this.setState({isViewer: userLib.isCustomViewer(this.props.currentUser, 'clinic')});

        if (this.props.rowDataClinics.length === 0) {
            try {
                const clinics = await this.clinics("");
                let tempResult = clinics;
                while (tempResult.LastEvaluatedKey) {
                    tempResult = await this.clinics(tempResult.LastEvaluatedKey);
                    clinics.Items = clinics.Items.concat(tempResult.Items);
                }
                this.props.setRowDataClinics(clinics.Items);
                this.setState({isEditor: userLib.isCustomEditor(this.props.currentUser, 'clinic')});
                this.setState({isViewer: userLib.isCustomViewer(this.props.currentUser, 'clinic')});
            } catch (e) {
                API.handleApiErrorWithAlert(e, this);
            }
        } else {
            this.setState({isEditor: userLib.isCustomEditor(this.props.currentUser, 'clinic')});
            this.setState({isViewer: userLib.isCustomViewer(this.props.currentUser, 'clinic')});

        }
        this.props.setUpdateTimeOutListener();
        this.setState({isLoading: false});
    }

    clinics(lastEvaluatedKey) {
        let myInit = {
            queryStringParameters: {}
        };
        if (lastEvaluatedKey && ("" !== lastEvaluatedKey.clinicID)) {
            myInit.queryStringParameters.ExclusiveStartKey = lastEvaluatedKey.clinicID;
        }
        return API.get("pumps", "/clinics", myInit);
    }

    onFilterTextBoxChanged() {
        if (this.gridApi) {
            const value = document.getElementById('filter-text-box').value;
            this.props.setSearchBox(value);
            this.gridApi.setGridOption("quickFilterText", value);
        }
    }

    onAddClinic() {
        this.props.setClinicToDuplicate(null);
        this.props.history.push('/clinics/new');
    }

    onDuplicateClinic() {
        this.props.setClinicToDuplicate(this.state.selectedClinics);
        this.props.history.push('/clinics/new');
    }

    onBtExport() {
        const params = {
            skipHeader: false,
            skipFooters: false,
            skipGroups: false,
            skipPinnedTop: false,
            skipPinnedBottom: false,
            allColumns: true,
            onlySelected: false,
            suppressQuotes: true,
            fileName: "CamAPS clinics",
            columnSeparator: ',',
            customHeader: "CamAPS clinics\n"
        };
        this.gridApi.exportDataAsCsv(params);
    }

    renderClinicsList() {
        return (
            <div style={{width: "100%", height: "100%"}}>
                <div className="pump-container">
                    <div className="page-container">
                        {this.state.isEditor ?
                            <Button className="button-add pull-left" bsStyle="primary" bsSize="small"
                                    onClick={this.onAddClinic.bind(this)}>
                                Add clinic
                            </Button> : null
                        }
                        {this.state.isEditor ?
                            <Button className="button-duplicate pull-left" bsStyle="primary" bsSize="small"
                                    margin-left={20}
                                    disabled={this.state.selectedClinics.length === 0}
                                    hidden={this.state.isEditor}
                                    onClick={this.onDuplicateClinic.bind(this)}>
                                Duplicate clinic
                            </Button> : null
                        }
                        <Button className="pull-right" bsStyle="info" bsSize="small"
                                onClick={this.onBtExport.bind(this)}>
                            <Glyphicon glyph="file"/> Export to Excel
                        </Button>
                    </div>
                    <div className="page-container">
                        <div className="page-size-header pull-left">
                            Page size:&nbsp;
                            <select onChange={this.onPageSizeChanged.bind(this)} id="page-size" defaultValue={'100'}>
                                {/*<select id="page-size" defaultValue={'100'}>*/}
                                <option value="10">10</option>
                                <option value="100">100</option>
                                <option value="500">500</option>
                                <option value="1000">1000</option>
                            </select>
                        </div>
                        <input className="pull-right" type="text" id="filter-text-box" placeholder="Search..."
                               onInput={this.onFilterTextBoxChanged.bind(this)}/>
                    </div>
                    <div style={{minHeight: "400px", height: "calc(100% - 30px)"}}>
                        <div
                            id="usersGrid"
                            style={this.state.style}
                            className="ag-theme-balham"
                        >
                            <AgGridReact
                                columnDefs={this.state.columnDefs}
                                defaultColDef={this.state.defaultColDef}
                                rowSelection={this.state.rowSelection}
                                onGridReady={this.onGridReady}
                                enableCellTextSelection={true}
                                onSelectionChanged={this.onSelectionChanged.bind(this)}
                                pagination={true}
                                paginationPageSize={this.state.paginationPageSize}
                                paginationNumberFormatter={this.state.paginationNumberFormatter}
                                rowData={this.props.rowDataClinics}
                                headerHeight={58}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderLander() {
        return (
            <div className="lander">
                <h1>Access not allowed. Not authenticated</h1>
            </div>
        );
    }

    getHeader() {
        if (this.state.isLoading) {
            return ('Loading ...');
        } else if (!this.props.rowData || (this.props.rowData.length === 0)) {
            return ('CamAPS clinics');
        } else {
            return ('All CamAPS clinics');
        }
    }

    renderClinics() {
        return (
            <div className="pumps">
                {/*<div className="left-header pull-left">*/}
                <PageHeader>
                    <div className="header">
                        <div className="left-header pull-left">
                            {this.getHeader()}
                        </div>
                        <div className="clearfix"/>
                    </div>
                </PageHeader>
                {!this.state.isLoading && this.renderClinicsList()}
            </div>
        );
    }

    render() {
        return (
            <div className="Home">
                {this.props.isAuthenticated ? this.renderClinics() : this.renderLander()}
            </div>
        );
    }
}
